<template>
  <div style="width: 100%">
    <div>
      <van-nav-bar
        title="入库上架"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      >
        <template #right>
          <van-icon name="home-o" size="25" @click="goIndex()" />
        </template>
      </van-nav-bar>
    </div>
    <div>
      <van-cell-group>
        <van-field ref="barcode" v-model="barcode" autofocus label="条码" left-icon="photograph" placeholder="请扫描条码" @keyup="onBarcode" />
      </van-cell-group>
    </div>
    <div>
      <van-row type="flex">
        <van-col span="24">
          <van-field ref="location" v-model="location" label="实际货位" name="实际货位" placeholder="编辑货位" @keyup="onLocation" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.allocateLocation.no" :readonly="true" label="上架货位" name="上架货位" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.storageRoom.name" :readonly="true" label="库房名称" name="库房名称" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.item.no" :readonly="true" label="商品编号" name="商品编号" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.item.name" :readonly="true" label="通用名称" name="通用名称" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="12">
          <van-field v-model="result.pack.specification" :readonly="true" label="规格" name="规格" />
        </van-col>
        <van-col span="12">
          <van-field v-model="result.pack.uom" :readonly="true" label="单位" name="单位" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.dosageForm.name" :readonly="true" label="剂型" name="剂型" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.pack.factor" :readonly="true" label="包装" name="包装" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.lot.no" :readonly="true" label="批号" name="批号" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.lot.validUntil" :readonly="true" label="生产日期" name="生产日期" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.lot.validUntil" :readonly="true" label="效期" name="效期" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.command.allocateQuantity" :readonly="true" label="数量" name="数量" />
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          <van-field v-model="result.lot.manufacturer" :readonly="true" label="生产厂商" name="生产厂商" />
        </van-col>
      </van-row>
    </div>
    <van-button round block type="info" style="margin: 16px;" native-type="confirm" @click="confirm">确认</van-button>
  </div>
</template>


<script>
  import debounce from 'lodash/debounce'
  import { findAll, findOne, post } from '@/api/Api'
  import { Toast } from 'vant'
  import api from '@/api'
  import { removeNullValues } from '@/pdaView/utils'
  import { ReceiptCommandFactoryView } from '@/api/dto/view/ReceiptCommandFactoryView'

  export default {
    components: {},
    data() {
      return {
        title: '入库上架',
        barcode: '',
        result: new ReceiptCommandFactoryView(),
        'location': null
      }
    },
    methods: {
      onClickLeft() {
        this.$router.back()
      },
      goIndex() {
        this.$router.push({ name: 'PdaIndex' }, (res) => {
        })
      },
      onBarcode: debounce(function(data, event) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.scan(value)
        }
      }, 300),
      pageChange(page) {
        this.result = this.resultArr[page - 1]
      },
      clear() {
        this.result = new ReceiptCommandFactoryView()
        this.barcode = ''
        this.location = null
        this.$refs.barcode.focus()
      },
      scan(value) {
        if (!value) {
          Toast('请输入条码！')
          return
        }
        const args = {
          'commandId': value,
          commandStatusRange: {
            start: 'GENERATED',
            end: 'PUTAWAY_OBTAINED'
          }
        }
        findAll('receiptCommandFactory', args).then(res => {
          if (res.result.length > 0) {
            let item = res.result[0]
            item.countable = (item.command.allocateQuantity - item.command.allocateQuantity % item.pack.factor) / item.pack.factor
            Object.assign(this.result, removeNullValues(item))
            this.$refs.location.focus()
          } else {
            Toast('条码不存在')
            this.clear()
          }
        })
      },
      onLocation: debounce(function(data, event) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.findLocation(value)
        }
      }, 300),
      findLocation(value) {
        if (!value) {
          Toast('请输入货位号')
          return
        }
        findOne('locationFactory', { 'location.no': value }).then(res => {
          this.location = res.result.no
        })
      },
      confirm() {
        if (!this.result.item) {
          Toast('请先扫码！')
          return
        }
        if (!this.location) {
          Toast('货位名称不能为空')
          return
        }
        let args = [{
          id: this.result.command.id,
          putawayQuantity: this.result.command.allocateQuantity,
          putawayLocation: {
            no: this.location
          }
        }]
        console.log(args)
        post(api.receivingReceiverCommandsPutaway, { type: '' }, args).then(res => {
          if (res.success) {
            Toast('入库上架成功')
            this.clear()
          }
        })
      }
    }
  }
</script>